export default __webpack_public_path__ + "static/media/bottles.bab1de34.jpeg";